<p-toast></p-toast>
<div class="app-verification-container mt-2">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4" reflow="true">
                <ng-template pTemplate="left">
                    
                </ng-template>
                <ng-template pTemplate="right">
                    <button *ngIf="canalMasterData.length>0" (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}"
                        icon="pi pi-upload" class="p-button-help"></button>
                        <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                        class="p-button-info ml-3"></button>
                </ng-template>
            </p-toolbar>
            <p-table #cropMasterTable [value]="canalMasterData" [paginator]="true" [globalFilterFields]="[
                    'Crop_Name',
                    'TotalApp',
                    'Status',
                    'documentID',
                    'endDate',
                    'fromDate',
                    'AreaAcre'
                    ]" responsiveLayout="scroll" [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
                [rowsPerPageOptions]="[10,25,50,100]" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'CROP_WISE'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="cropMasterTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" class="tableHeader">
                    <tr>
                        <th pSortableColumn="Crop_Name">{{'CROP_NAME'| translate}}
                            <p-columnFilter type="text" field="Crop_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Crop_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TotalApp">{{'TOTAL_APPLICATIONS'| translate}}
                            <p-columnFilter type="text" field="TotalApp" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalApp"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AreaAcre">{{'TARGET_AREA'| translate}}
                            <p-columnFilter type="text" field="AreaAcre" display="menu"></p-columnFilter>
                            <p-sortIcon field="AreaAcre"></p-sortIcon>
                        </th>
                        <th pSortableColumn="documentID">{{'OFFICE_ORDER_NO'| translate}}
                            <p-columnFilter type="text" field="documentID" display="menu"></p-columnFilter>
                            <p-sortIcon field="documentID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="DocumentPath">{{'VIEW_OFFICE_ORDER_COPY'| translate}}
                            <!-- <p-columnFilter type="text" field="DocumentPath" display="menu"></p-columnFilter>
                            <p-sortIcon field="DocumentPath"></p-sortIcon> -->
                        </th>
                        <th pSortableColumn="fromDate">{{'START_DATE'| translate}}
                            <p-columnFilter type="text" field="fromDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="fromDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="endDate">{{'END_DATE'| translate}}
                            <p-columnFilter type="text" field="endDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="endDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Status">{{'CURRENT_STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status"></p-sortIcon>
                        </th>
                        <th pSortableColumn="">{{'ACTION'| translate}} </th>

                        <!-- <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}} </th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <!-- <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}"> -->
                    <tr>
                        <td>{{product?.Crop_Name}}</td>
                        <td>{{product?.TotalApp}}</td>
                        <td>{{product?.AreaAcre}}</td>
                        <td>{{product?.documentID}}</td>
                        <td><a *ngIf="product?.DocumentPath" style="cursor: pointer" [href]="product?.DocumentPath"
                                target="_blank">{{'VIEW_DOC' | translate}}</a></td>
                        <td>{{product?.fromDate | date:'mediumDate'}}</td>
                        <td>{{product?.endDate | date:'mediumDate'}}</td>
                        <td>
                            <button *ngIf="product?.Status == 'Open'" pButton pRipple type="button"
                                class="p-button-rounded p-button-success" label="{{ product?.Status }}"></button>
                            <button *ngIf="product?.Status == 'Close'" pButton pRipple type="button"
                                class="p-button-rounded p-button-danger" label="{{ product?.Status }}"></button>
                        </td>
                        <td>
                            <button *ngIf="product?.Status == 'Close'" pButton pRipple type="button" pTooltip=""
                                (click)="updateAction(product)" icon="pi pi-pencil" class="p-button-rounded"></button>
                        </td>
                        <!-- <td>
                                <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="printForm(product.appID,product?.Status_Ar,product?.ProgramID)"></button>
                                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                    (click)="deleteProduct(product)"></button>
                            </td>
                            <td *ngIf="product.EstimationStatus==2">
                                <button pButton pRipple type="button" pTooltip="Add-Estimation" icon="pi pi-plus"
                                    class="p-button-rounded p-button-text" (click)="addEstimation(product)"></button>
                            </td>
                            <td *ngIf="product.EstimationStatus==1">
                                <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                    (click)="updateEstimation(product)" icon="pi pi-pencil"
                                    class="p-button-rounded p-button-text"></button>
                                <button pButton pRipple type="button" pTooltip="Delete-Estimation" icon="pi pi-times"
                                    class="p-button-rounded p-button-text p-button-danger"
                                    (click)="deleteEstimation(product)"></button>
                            </td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{canalMasterData ? canalMasterData.length : 0 }}
                        {{'CROP_WISE'| translate}}
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-dialog [(visible)]="showDialogToUpdateStatus" [style]="{width: '700px', height: '380px'}"
    header="{{ 'UPDATE_STATUS' | translate}}" [modal]="true" [baseZIndex]="-100" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="updateStatusForm">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <label htmlFor="documentID">{{'OFFICE_ORDER_NO' | translate}}</label>
                    <input formControlName="documentID" pInputText id="documentID" type="text"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.documentID.errors }" />

                    <div *ngIf="isSubmitted && updateStatusFormControls.documentID.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.documentID.errors.required">{{'OFFICE_ORDER_NO_IS_REQUIRED'
                            |
                            translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="block">{{'START_DATE' | translate}}</label>
                    <p-calendar appendTo="body" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                        formControlName="fromDate"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.fromDate.errors }"></p-calendar>
                    <div *ngIf="isSubmitted && updateStatusFormControls.fromDate.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.fromDate.errors.required">{{'START_DATE_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="block">{{'END_DATE' | translate}}</label>
                    <p-calendar appendTo="body" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                        formControlName="endDate"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.endDate.errors }"></p-calendar>
                    <div *ngIf="isSubmitted && updateStatusFormControls.endDate.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.endDate.errors.required">{{'END_DATE_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="area">{{'TARGET_AREA' | translate}}</label>
                    <input formControlName="area" pInputText id="area"
                        type="number" min="0" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.documentID.errors }" />
                    <div *ngIf="isSubmitted && updateStatusFormControls.area.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.area.errors.required">{{'TARGET_AREA_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="documentPath">{{'UPLOAD_OFFICE_ORDER_COPY' | translate}}</label>
                    <div class="flex">
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" #documentFileUpload [customUpload]="true"
                            (uploadHandler)="onUpload($event, 'documentPath', documentFileUpload)" name="myfile[]"
                            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                        </p-fileUpload>
                        <p-image *ngIf="updateStatusFormControls.documentPath.value"
                            [src]="updateStatusFormControls.documentPath.value" alt="Image" width="60"
                            class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                    </div>
                    <div *ngIf="isSubmitted && updateStatusFormControls.documentPath.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.documentPath.errors.required">{{'OFFICE_ORDER_COPY_IS_REQUIRED' |
                            translate}}</div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
            (click)="saveProduct()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>